"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTypeHandler = void 0;
const React = require("react");
const react_1 = require("react");
const TSalesOrderType_1 = require("../../types/TSalesOrderType");
const OrderTypeContext_1 = require("../../contexts/OrderTypeContext");
const constants_1 = require("../../helpers/constants");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
const PersistenceContext_1 = require("../../../../../contexts/PersistenceContext");
/**
 * Provide the chosen order type for the ordering app
 */
const OrderTypeHandler = ({ initialOrderType, children }) => {
    const { getItem, removeItem, setItem } = (0, useRequiredContext_1.useRequiredContext)(PersistenceContext_1.PersistenceContext);
    const [orderType, setOrderType] = (0, react_1.useState)(initialOrderType);
    const resetOrderType = (0, react_1.useCallback)(async () => {
        if (initialOrderType) {
            setOrderType(initialOrderType);
            return;
        }
        const localStorageOrderType = (await getItem(constants_1.TOrderingLocalStorageKeys.OrderType));
        if (![TSalesOrderType_1.TSalesOrderType.Pickup, TSalesOrderType_1.TSalesOrderType.Delivery].includes(localStorageOrderType)) {
            setOrderType(TSalesOrderType_1.TSalesOrderType.Pickup);
            return;
        }
        setOrderType(localStorageOrderType);
    }, [initialOrderType]);
    (0, react_1.useEffect)(() => {
        (async () => {
            await resetOrderType();
        })();
    }, []);
    (0, react_1.useEffect)(() => {
        if (!orderType) {
            removeItem(constants_1.TOrderingLocalStorageKeys.OrderType).catch(console.error);
            return;
        }
        setItem(constants_1.TOrderingLocalStorageKeys.OrderType, orderType).catch(console.error);
    }, [orderType]);
    const provider = (0, react_1.useMemo)(() => {
        return {
            orderType,
            setOrderType,
            resetOrderType
        };
    }, [orderType, setOrderType, resetOrderType]);
    return (React.createElement(OrderTypeContext_1.OrderTypeContext.Provider, { value: provider }, children));
};
exports.OrderTypeHandler = OrderTypeHandler;
//# sourceMappingURL=index.js.map